import React, {useId, useRef, useState} from 'react';
import {Dialog} from "primereact/dialog";
import {Button} from "primereact/button";
import {useDispatch, useSelector} from "react-redux";
import {useTranslate} from "../../system/useTranslate";
import InputLabel from "../../system/components/input-label";
import Icon from "../../system/components/icon";
import {SelectButton} from "primereact/selectbutton";
import {setMessage} from "../../system/app-slice";
import {farsiDigitsToInt} from "../../system/utils";
import WorkspaceInvitation from "../../models/workspace-invitation/workspace-invitation";

export function submitWorkspaceInvitation(inviteData, workspace, client = new WorkspaceInvitation()) {
    return client.invite(
        {...inviteData, workspaceId: workspace?.id},
        workspace?.documentId,
    );
}

function InviteMemberDialog({visible, setVisible, onSubmit}) {

    const translate = useTranslate();
    const [inviteData, setInviteData] = useState({role:"viewer"});
    const [submitting, setSubmitting] = useState(false);
    const submitLockRef = useRef(false);
    const formId = useId();
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const dispatch = useDispatch();

    const roleOptions = [
        {
            label:translate("guest"),
            value:"guest",
            className:"flex-1 text-xs"
        },
        {
            label:translate("workspace-member"),
            value:"viewer",
            className:"flex-1 text-xs"
        }
    ]


    const createWorkspaceInvite = async (_inviteData)=>{
        if (submitting || submitLockRef.current) return;
        submitLockRef.current = true;
        setSubmitting(true);
        const workspace = workspaceMembershipData?.workspace;
        _inviteData = {..._inviteData, workspaceId: workspace?.id}
        try {
            await submitWorkspaceInvitation(_inviteData, workspace);
            onSubmit?.(_inviteData);
            setVisible?.(false);
            dispatch(setMessage({severity:"info", content:translate("workspace-invitation.sent")}))
            // dispatch(setWorkspaceMemberships(_data?.data));
            // dispatch(setWorkspaceMembership((_data?.data.find(e=>e.isDefault))));
        }catch (e) {
            dispatch(setMessage({severity:"error", content:translate(e?.message || "workspace-invitation.error.send")}))
        }finally {
            submitLockRef.current = false;
            setSubmitting(false);
        }
    }

    return (
        <Dialog pt={{footer:()=>({className:"p-0 border-round-bottom-2xl"}), content:()=>({className:"p-0 h-full"})}} header={<Header />} contentClassName="p-4" headerClassName="border-round-top-2xl border-bottom-1 border-300 pb-3 pt-3" footer={<Footer formId={formId} setVisible={setVisible} submitting={submitting}/>} className="rtl w-4 border-round-bottom-2xl" visible={visible} onHide={()=>{setVisible(false)}}>
            <form id={formId} className="flex flex-column gap-3" onSubmit={(event) => {
                event.preventDefault();
                createWorkspaceInvite(inviteData);
            }}>
                <span className="text-xs text-400">{translate("invite-member-description")}</span>
                <div className="flex flex-wrap gap-2 w-full">
                    <InputLabel require className="w-full" inputType="TEXT" label={translate("fullname")} value={inviteData?.fullname} onChange={(e)=>{setInviteData({...inviteData, fullname:e.target.value})}}/>
                    <InputLabel require className="w-full" inputType="TEXT" label={translate("mobile")} value={inviteData?.phonenumber} onChange={(e)=>{setInviteData({...inviteData,  phonenumber:farsiDigitsToInt(e.target.value)})}}/>
                    <InputLabel info={translate("workspace-members-info")} require className="w-full" label={translate("role")}>
                        <SelectButton className="ltr w-full flex" options={roleOptions} value={inviteData?.role} optionValue={"value"} onChange={(e)=>{setInviteData({...inviteData, role:e.value})}}/>
                    </InputLabel>
                </div>

            </form>
        </Dialog>
    );
}


function Header() {
    const translate = useTranslate();
    return(
        <div className="flex flex-column">
            <span className="text-lg">{translate("invite-member")}</span>
            {/*<span className="text-xs text-400">{teamData?.name}</span>*/}
        </div>
    )
}
function Footer({formId, setVisible, submitting}) {
    const translate = useTranslate();
    return(
        <div className="flex flex-row-reverse align-items-center gap-2 justify-content-start p-3 surface-50 border-round-bottom-2xl border-top-1 border-300">
            <Button type="submit" form={formId} icon={<Icon icon="mi mi:upload" className="text-lg"/>} className="text-xs flex gap-2 border-round-lg p-2" label={translate("send-invite")} disabled={submitting} loading={submitting}/>
            <Button type="button" className="text-xs p-button-secondary p-button-outlined border-round-lg p-2" label={translate("cancel")} disabled={submitting} onClick={()=>{setVisible(false)}}/>
        </div>
    )
}

export default InviteMemberDialog;
